Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "QuantityCounter1985873316",
  {"quantityCounter":"QuantityCounter1985873316--quantityCounter","root":"QuantityCounter1985873316--root"},
  "",
  9,
  "QuantityCounter1985873316"
);

